import { TableCell, TableRow } from '@mui/material';
import React from 'react';
import { IAbstractRecord } from '@models';

interface IEmptyHeader {
  width: number;
  height: number;
  classes: IAbstractRecord;
  children: React.ReactNode;
}

const EmptyTableRow: React.FC<IEmptyHeader> = ({ children, width, height }) => {
  return (
    <TableRow>
      <TableCell
        rowSpan={2}
        colSpan={width > 0 ? width + 1 : 1}
        style={{ height: height }}
        align="center"
      >
        {children}
      </TableCell>
    </TableRow>
  );
};

export default EmptyTableRow;
